import React from "react";
import NavHeader from '../NavHeader/navheader';
import Progressbar from '../ProgressBar/progressbar';
import TestButton from '../TestButton/testbutton';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Portfolio from '../PortfolioImage/portfolio';
import { Col, Row, Container } from 'react-bootstrap';
import PortfolioSallie from '../../images/min-salliemae.jpg';
import PortfolioComponent from '../../images/min-component-library.jpg';
import PortfolioOLS from '../../images/min-ols.jpg';
import PortfolioBDS from '../../images/min-brooklinedriving.jpg';
import PortfolioGardenscape from '../../images/min-gardenscape.jpg';
import PortfolioCathy from '../../images/min-cathy.jpg';
import PortfolioBTS from '../../images/min-btsfunds.jpg';
import PortfolioBrenda from '../../images/min-brendalovette.jpg';
import PortfolioCalc from '../../images/min-paymentcalculator.jpg';
import PortfolioNative from '../../images/min-nativeapp.jpg';
import PortfolioPersonal from '../../images/min-personalloan.jpg';
import PortfolioPaws from '../../images/min-pawsnwalks.jpg';
import Eddie from '../../images/eddie.jpg';
import Testimonials from '../Testimonials/testimonials';
import Carousel from 'react-bootstrap/Carousel';
import CarouselSallie from '../../images/gallery-salliemae.jpg';
import CarouselComponent from '../../images/gallery-component-library.jpg';
import CarouselBDS from '../../images/gallery-brooklinedriving.jpg';
import CarouselGardenscape from '../../images/gallery-gardenscape.jpg';
import CarouselPaws from '../../images/gallery-pawsnwalks.jpg';
import EmailForm from '../EmailForm/emailform';
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  return (
    <>
    <NavHeader />
    <Progressbar />
    <main className='container-fluid'>
    <section id='featured'>
      <Container>
        <Row>
          <Col>
            <h2>Featured work</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <Carousel>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={CarouselSallie} // Use the imported image as the src
                  alt="First slide"
                />
                <Carousel.Caption>
                  <p>Built Sallie Mae's web site.</p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={CarouselGardenscape} // Use the imported image as the src
                  alt="Second slide"
                />
                <Carousel.Caption>
                  <p>Designed and developed web site for landscaping business.</p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={CarouselBDS} // Use the imported image as the src
                  alt="Third slide"
                />
                <Carousel.Caption>
                  <p>Designed and developed web site for driving school.</p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={CarouselComponent} // Use the imported image as the src
                  alt="Fourth slide"
                />
                <Carousel.Caption>
                  <p>Designed and developed React component library for Sallie Mae.</p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={CarouselPaws} // Use the imported image as the src
                  alt="Fifth slide"
                />
                <Carousel.Caption>
                  <p>Designed and developed web site for pet business.</p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </section>
    <section id='testimonials'>
      <Container>
        <Row>
          <Col>
            <h2>Testimonials</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <Testimonials quote='I am very happy with Web Design of Boston and would highly recommend them. I absolutely love both the aesthetics and functionality of my new website, which has seen more traffic in the last two months than my last web provider&apos;s service in a year! Also, in my experience as a woman entrepreneur, I particularly appreciate Eddie&apos;s professionalism. My ideas and concerns are taken seriously and responded to quickly. Muchas gracias, Eddie!' quotedby='Kris Quinones, puravidahealing.org' />
          </Col>
          <Col xs={12} lg={6} className='mt-5 mt-lg-0'>
            <Testimonials quote='Web Design of Boston was recommended by a colleague when our site went down and we didn&apos;t know the cause. Not only did Web Design of Boston come to our rescue and solve the problem in an instant, but we kept them on-board to give our site a more modern look with better functionality. They are a pleasure with which to work and always deliver more than asked. We are better with Web Design of Boston on our team!' quotedby='George Bausewein, ADEK Industrial Computers' />
          </Col>
        </Row>
      </Container>
    </section>
    <section id='portfolio'>
      <Container>
        <Row>
          <Col xs={12}>
            <h2>Portfolio</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='https://www.webdesignofboston.com/portfolio/slm.com/' src={PortfolioSallie} figcaption='Salliemae' alt='Salliemae.com screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='https://www.webdesignofboston.com/portfolio/design-system-react/index.html' src={PortfolioComponent} figcaption='React component library' alt='React component library screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='https://www.webdesignofboston.com/portfolio/ols/' src={PortfolioOLS} figcaption='Salliemae OLS' alt='Salliemae OLS screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='https://www.brooklinedriving.com' src={PortfolioBDS} figcaption='Brookline Driving School' alt='Brookline Driving School screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='http://www.gardenscape-landscaping.com' src={PortfolioGardenscape} figcaption='Gardenscape Landscaping' alt='Gardenscape Landscaping screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='http://www.cathyvenditti.com' src={PortfolioCathy} figcaption='Cathy Venditti' alt='Cathy Venditti screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='http://www.btsfunds.com' src={PortfolioBTS} figcaption='BTS Funds' alt='BTS Funds screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='http://brendalovette.com' src={PortfolioBrenda} figcaption='Brenda Lovette' alt='Brenda Lovette screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='https://www.webdesignofboston.com/portfolio/payment-calculator/index.html' src={PortfolioCalc} figcaption='Payment calculator' alt='Payment calculator screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='https://www.webdesignofboston.com/portfolio/native-app-evolution/index.html' src={PortfolioNative} figcaption='Native app evolution' alt='Native app evolution screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='https://www.webdesignofboston.com/portfolio/personal-loan/redeem-offer.html' src={PortfolioPersonal} figcaption='Personal loan' alt='Personal loan screenshot' />  
          </Col>
          <Col xs={12} md={6} xl={4}>
            <Portfolio link='http://www.pawsnwalks.com' src={PortfolioPaws} figcaption='Paws n&apos; Walks' alt='Paws n&apos; Walks screenshot' />  
          </Col>
        </Row>
      </Container>
    </section>
    <section id='about'>
      <Container>
        <Row>
          <Col>
            <h2>About</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={9}>
            <h3 className='mt-0'>Eddie Strizhiver - Founder, Web Designer, Web Developer</h3>
            <p>I've held titles of web designer, front end developer, web developer, web master, UX engineer, and web manager - but they all pretty much mean the same thing - I design and develop responsive and accessible web sites and web apps!</p>
            <p>I've worked with start-ups, large corporations, and small businesses. I specialize in design, development, web site maintenance, SEO, and building sites for desktops and mobile devices.</p>
            <p>Depending on the complexity of the project, I'll bring in other engineers and developers to assist me.</p>
            <TestButton
              className="mb-4"
              variant="primary"
              onClick={() => {
                navigate("/portfolio"); // Navigate to the /portfolio route
              }}
              endIcon={<ChevronRightIcon />}
            >
              More detailed portfolio
            </TestButton>
            <h3>Skills</h3>
            <p className="buttonContainer">
              <TestButton variant='secondary'>Figma design</TestButton>
              <TestButton variant='secondary'>Figma prototyping</TestButton>
              <TestButton variant='secondary'>Design systems</TestButton>
              <TestButton variant='secondary'>HTML5</TestButton>
              <TestButton variant='secondary'>CSS/SCSS</TestButton>
              <TestButton variant='secondary'>React</TestButton>
              <TestButton variant='secondary'>JavaScript</TestButton>					
              <TestButton variant='secondary'>WCAG compliance</TestButton>
              <TestButton variant='secondary'>Axe accessibility</TestButton>
              <TestButton variant='secondary'>Bootstrap</TestButton>
              <TestButton variant='secondary'>Responsive</TestButton>
              <TestButton variant='secondary'>Photoshop</TestButton>
              <TestButton variant='secondary'>Google Search Console</TestButton>
              <TestButton variant='secondary'>SEO</TestButton>
              
            </p>
            <h3>Interests</h3>
            <p className="buttonContainer">
              <TestButton variant='secondary'>Adventure travel</TestButton>
              <TestButton variant='secondary'>Problem solving</TestButton>
              <TestButton variant='secondary'>Building stuff</TestButton>
              <TestButton variant='secondary'>Reading</TestButton>
              <TestButton variant='secondary'>Skiing</TestButton>
              <TestButton variant='secondary'>Cycling</TestButton>
              <TestButton variant='secondary'>Sports</TestButton>
              <TestButton variant='secondary'>Fitness</TestButton>
            </p>
          </Col>
          <Col xs={12} lg={3}>
          <figure>
          <img src={Eddie} alt="Eddie Strizhiver" className="img-fluid" />
          <figcaption>
            <a className="pdf" href="https://www.webdesignofboston.com/docs/Edward-Strizhiver-Resume.pdf" target="_blank" rel="noreferrer">
              <span className="material-symbols-outlined">
                description
              </span>Resume
            </a>
          </figcaption>
        </figure>
          </Col>
        </Row>
      </Container>
    </section>
    <section id='contact'>
      <Container>
        <Row>
          <Col>
            <h2>Contact</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={7} className='mb-5'>
            <EmailForm />
          </Col>
          <Col xs={12} lg={4} className='mt-5 mt-lg-0 offset-lg-1'>
            <h3 className='mt-0'>Web Design of Boston</h3>
            <p>Eddie Strizhiver
              <br/>Email: <a href="mailto:estrizhiver@gmail.com">estrizhiver@gmail.com</a>
              <br/>Phone: <a href="tel:617-513-9868">617.513.9868</a>
              <br/>LinkedIn: <a href="https://www.linkedin.com/in/edward-strizhiver" target="_blank" rel="noreferrer">linkedin.com/in/edward-strizhiver</a>
              <br/>Resume: <a href="https://www.webdesignofboston.com/docs/Edward-Strizhiver-Resume.pdf" target="_blank" rel="noreferrer">PDF version</a>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  </main>
  </>
  );
};

export default Home;